module.exports = __webpack_public_path__ + "9f3a7aee71434f5c16b58a24a240dd40.woff2";